import React, { useState } from 'react';
import './App.css';

// Import images and video
import artistPhoto from './media/artist-photo.jpg';
import video from './media/exposition.mp4';

// Desastre Artwork Images
import Desastre from './media/Desastre.jpg';
import Desastre1 from './media/Desastre1.jpg';
import Desastre2 from './media/Desastre2.jpg';
import Desastre3 from './media/Desastre3.jpg';
import Desastre4 from './media/Desastre4.jpg';
import Desastre5 from './media/Desastre5.jpg';
import Desastre6 from './media/Desastre6.jpg';
import Desastre7 from './media/Desastre7.jpg';
import Desastre8 from './media/Desastre8.jpg';
import Desastre9 from './media/Desastre9.jpg';

// Difficile Artwork Images
import Difficile1 from './media/Difficile1.jpg';
import Difficile2 from './media/Difficile2.jpg';
import Difficile3 from './media/Difficile3.jpg';
import Difficile4 from './media/Difficile4.jpg';

// Certificate Images
import CertificateDesastre from './media/Certificate_Desastre.jpg';
import CertificateDifficile from './media/Certificate_Difficile.jpg';

// Escrow image
import EscrowImage from './media/Escrow.png';

const App = () => {
  // Desastre state for managing image index
  const [desastreIndex, setDesastreIndex] = useState(0);
  const desastreImages = [Desastre, Desastre1, Desastre2, Desastre3, Desastre4, Desastre5, Desastre6, Desastre7, Desastre8, Desastre9, CertificateDesastre];

  // Difficile state for managing image index
  const [difficileIndex, setDifficileIndex] = useState(0);
  const difficileImages = [Difficile1, Difficile2, Difficile3, Difficile4, CertificateDifficile];


  // Functions for changing images
  const nextDesastreImage = () => {
    setDesastreIndex((prevIndex) => (prevIndex + 1) % desastreImages.length);
  };

  const nextDifficileImage = () => {
    setDifficileIndex((prevIndex) => (prevIndex + 1) % difficileImages.length);
  };


  return (
    <div className="app">
      <header className="header">
        <h1>Haitian Art Sale</h1>
        <p>Exclusive Artworks by Frankétienne</p>
      </header>

      <section className="artist-info">
        <div className="artist-photo">
          <img src={artistPhoto} alt="Frankétienne" />
        </div>
        <div className="artist-bio">
          <h2>About the Artist</h2>
          <p>
            Frankétienne is a renowned Haitian artist, poet, and playwright whose works have been featured in numerous exhibitions worldwide. His artistic vision captures the soul of Haiti, blending historical narratives with contemporary insights. His vibrant pieces explore the complexity of the human experience, often highlighting themes of resilience, struggle, and beauty.
          </p>
        </div>
      </section>

      <section className="artwork">
        <h2>Featured Artworks</h2>

        <div className="artwork-item">
          <h3>Désastre 12 Janvier 2010</h3>
          <p className="price">USD 4000</p>
          <div className="image-gallery">
            <img src={desastreImages[desastreIndex]} onClick={nextDesastreImage}  alt="Désastre 12 Janvier 2010" />
          </div>

          <p className="description">
            This powerful painting commemorates the tragic earthquake that devastated Haiti on January 12, 2010. It symbolizes the pain, loss, and the collective resilience of the Haitian people.
          </p>

          <section className="article-link">
          <a href="https://en.wikipedia.org/wiki/D%C3%A9sastre_(12_janvier_2010)" target="_blank" rel="noopener noreferrer">
            Learn More About Désastre 12 Janvier 2010
          </a>
        </section>
        </div>



        <div className="artwork-item">
          <h3>Difficile Emergence vers la lumière</h3>
          <p className="price">USD 3000</p>
          <div className="image-gallery">
            <img src={difficileImages[difficileIndex]} onClick={nextDifficileImage}  alt="Difficile Emergence vers la lumière" />
          </div>

          <p className="description">
            A poignant reflection on Haiti’s resilience in the wake of devastating hurricanes, this painting captures the struggle and strength of the Haitian people as they rise from the aftermath. It symbolizes their enduring hope and determination, as they emerge from the darkness of disaster toward the light of renewal and progress.
          </p>

          <section className="article-link">
          <a href="https://en.wikipedia.org/wiki/Difficile_%C3%A9mergence_vers_la_lumi%C3%A8re" target="_blank" rel="noopener noreferrer">
            Learn More About Difficile Emergence vers la lumière
          </a>
        </section>
        </div>

  


      </section>



      <section className="video">
        <h2>Watch the Artist's Interview</h2>
        <video controls width="100%" height="auto">
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </section>

      <section className="article-link">
        <h2>Learn More About the Exhibition</h2>
        <p>For more details about the artist's exhibition, read the full article below:</p>
        <a href="https://lenouvelliste.com/article/129840/vibrant-hommage-a-franketienne" target="_blank" rel="noopener noreferrer">
          Read the Article
        </a>
      </section>

      <section className="contact">
        <h2>Contact Information</h2>
        <p>Email: <a href="mailto:contact@haitianartsale.com">contact@haitianartsale.com</a></p>
        <p>Location: Santiago, Dominican Republic</p>
        <p>
          Escrow service is used to ensure secure payment and receipt of the artwork. Shipping and insurance are covered by the seller.
        </p>
        <div className="escrow-image">
          <img src={EscrowImage} alt="Escrow Service" />
        </div>
        <p>
          For more details, visit:
        </p>
        <a href="https://www.escrow.com" target="_blank" rel="noopener noreferrer">
          Escrow.com
        </a>
      </section>

      <section className="map">
        <h2>Santiago,</h2>
        <h2>Dominican Republic</h2>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3876.1479298083126!2d-70.68879138509092!3d19.45527739612979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8eaf998f64cf4c71%3A0xb8ed87ef18c9b2bb!2sMonumento%20a%20los%20H%C3%A9roes%20de%20la%20Restauraci%C3%B3n!5e0!3m2!1ses!2sdo!4v1634318967033!5m2!1ses!2sdo"
          width="600"
          height="450"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </section>

      <footer className="footer">
        <p>&copy; 2024 Haitian Art Sale. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
